import { Component, OnInit } from '@angular/core';
import { MenubarModule } from 'primeng/menubar';
import { ToolbarModule } from 'primeng/toolbar';
import { AvatarModule } from 'primeng/avatar';
import { CommonModule } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { SidebarModule } from 'primeng/sidebar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AccountService } from './service/account.service';
import { Router, RouterModule } from '@angular/router';

@Component({
    selector: 'main',
    standalone: true,
    imports: [CommonModule, MenubarModule, ToolbarModule, AvatarModule, MenuModule, ToastModule, RippleModule, SidebarModule, ConfirmDialogModule, RouterModule],
    template: `
        <div>
            <router-outlet></router-outlet>
        </div>
    `
})
export class MainComponent implements OnInit {
    constructor(
        protected account: AccountService,
        private router: Router
    ) {}

    ngOnInit() {
        this.account.identity().subscribe({
            next: () => {},
            error: () => this.router.navigate(['/auth/login'])
        });
    }
}
